<template>
  <div class="sfmyinfo">
    <div class="sp1"></div>
    <div class="con">
      <div class="conin">
        <van-form>
          <van-field
            class="myvanfield myvanhead"
            center
            clearable
            label="头像"
            disabled
          >
            <template #button>
              <div class="headcon">
                <img src="../../../assets/img/common/head.png" />
              </div>
            </template>
          </van-field>
          <van-field
            class="myvanfield"
            v-model="subdata.nname"
            label="昵称"
            placeholder="点击输入"
          />
          <van-field
            class="myvanfield"
            center
            clearable
            label="性别"
            disabled
          >
            <template #button>
              <div class="radiocon">
                <van-radio-group v-model="subdata.sex" icon-size="20">
                  <van-radio class="myradio" name="男">男</van-radio>
                  <van-radio name="女">女</van-radio>
                </van-radio-group>
              </div>
            </template>
          </van-field>
          <van-field
            class="myvanfield"
            v-model="subdata.mobile"
            label="手机号"
            placeholder="点击输入"
          />
        </van-form>
      </div>
    </div>

    <div class="sp1"></div>
    <div class="btncon">
      <van-button class="mybtn" type="primary" @click="gosub" block>保存</van-button>
      <van-button class="mybtn" type="primary" @click="loginOut" block>退出登陆</van-button>
    </div>
  </div>
</template>

<script>
import { personalInfo, savePerson } from '@/api/modules/user'
import { Toast } from 'vant'
export default {
  name: 'sfmyinfo',
  components: {
  },
  data() {
    return {
      subdata: {
        sex: '',
        nname: '',
        mobile: ''
      }
    }
  },
  computed: {
  },
  created() {
    personalInfo().then((res) => {
      console.log(res)
      if (res.data.status_code === 200) {
        this.subdata.sex = res.data.person.sex
        this.subdata.nname = res.data.person.nname
        this.subdata.mobile = res.data.person.mobile
      }
    })
  },
  methods: {
    loginOut() {
      alert('退出')
    },
    gosub() {
      savePerson({
        ...this.subdata
      }).then((res) => {
        if (res.data.status_code === 200) {
          Toast(res.data.msg)
        }

      })
    }
  }
}
</script>
<style lang="less">
  .myvanfield{
    .van-field__label {
      color:#646566 !important;
    }
  }
</style>
<style lang="less" scoped>
  .sfmyinfo{
    width:100%;
    min-height:100vh;
    background-color: #F3F3F3;
    .btncon{
      display:flex;
      justify-content: space-between;
      .mybtn{
        width:49%;
      }
    }
    .sp1{
      height:30px;
    }
    .con{
      width:100%;
      background-color:#ffffff;
      .conin{
        margin:0px 30px;
        .myvanfield{
          color:#646566 !important;
          border-radius:0px;
          border-bottom:1px solid #424242;
          .van-cell__title{
            color:#646566 !important;
          }
        }
        .myvanhead{
          height:130px;
        }
        .headcon{
          width:120px;
          height:120px;
          background: #99F7FF;
          border-radius: 50%;
          text-align:center;
          img{
            width:57px;
            height:auto;
            vertical-align: middle;
            margin-top:10px;
          }
        }
        .radiocon{
          width:160px;
          text-align:right;
          .myradio{
            margin-right:10px;
          }
          .van-radio-group{
            display:flex;
          }
          .myradio{
            font-size:30px;
          }
        }
      }
    }
    .mybtn{
      width: 750px;
      height: 94px;
      font-weight: 500;
      font-size: 36px;
      color: #000000;
      line-height: 48px;
      background-color:#ffffff;
      border:0px;
    }
  }
</style>
